import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vswk7rntc2: FaireBrandEntity = {
  token: "b_vswk7rntc2",
  type: "brand",
  name: "SP Sophia Collection",
  avatarUrl:
    "https://cdn.faire.com/fastly/4ea4bedbdac6a8c3ba91d0cae312eb586c02082409cb94ddfdff82203345ad63.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cee2ef226ca0673157b5388977e28a26f9b94151af8c841be1700bd622f377e7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4ea4bedbdac6a8c3ba91d0cae312eb586c02082409cb94ddfdff82203345ad63.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cee2ef226ca0673157b5388977e28a26f9b94151af8c841be1700bd622f377e7.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 447,
  isTopShop: true,
  isInsider: true,
  description:
    "***We Ship Out all in Stock Items and cancel all back orders. If you would like a full complete order, please send us message and we will do our best to accommodate. We appreciate your understanding***\n\n\nLife is filled with many joyous and celebratory milestones, which is then captured by everlasting photos and videos. What we wear to these special events takes some serious effort and time. \nWith over 40 years in the fashion accessories industry, our team has first hand access to beautiful and quality pieces at amazing prices.  In return, we can continuously provide the same to you, our most valued customers.  From hand crafted statement jewelry pieces to tailor-made fashion accessories, our team jumps through leaps and bounds to ensure our customers are getting the highest quality and trendy statement pieces.  \nLet US help YOU be the showstopper that you are.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:37.307Z",
    importedBy: "entity-db-cli",
  },
};
